import { Logger } from '@utils/logger';
import Config, { isLocalhost } from '../Config';

// dinamic import to download the package only on envs that will use it
const getFSModule = () => import('@fullstory/browser');

// make sure we are not using QA/prod config file while running locally
export const isFullstoryActive = () => Config.fullStory.active && !isLocalhost();

class FullStoryService {
  private static fullstory: any;

  // inject the module in the static methods
  // or prevent them from executing if fullstory is not active
  private static async runModuleFunction(
    callback: (module: Awaited<ReturnType<typeof getFSModule>>) => unknown,
  ) {
    if (!isFullstoryActive()) {
      Logger.warn('Fullstory is not active for this environment');
      return;
    }
    if (!FullStoryService.fullstory) {
      FullStoryService.fullstory = await getFSModule();
    }

    callback(FullStoryService.fullstory);
  }

  public static async init(): Promise<void> {
    this.runModuleFunction((module) => {
      module.init({ orgId: Config.fullStory.orgId });
    });
  }

  public static async identify(coachId: string): Promise<void> {
    this.runModuleFunction((module) => {
      module.identify(coachId, {
        env: process.env.REACT_APP_ENV,
        displayName: `userId ${coachId}`,
      });
    });
  }

  public static async shutdown(): Promise<void> {
    this.runModuleFunction((module) => {
      module.shutdown();
    });
  }
}

export default FullStoryService;
